export const saveFile = (blob: Blob, fileName: string) => {
  const link = document.createElement('a');
  link.download = fileName;
  link.href = URL.createObjectURL(blob);
  link.addEventListener('click', () => {
    setTimeout(() => URL.revokeObjectURL(link.href), 30 * 1000);
  });
  link.click();
};

export const sanitizeFilename = (name: string): string => {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
};
